import { render, staticRenderFns } from "./HumanCapitalSummary.vue?vue&type=template&id=4f502fca&scoped=true&"
import script from "./HumanCapitalSummary.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalSummary.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalSummary.vue?vue&type=style&index=0&id=4f502fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f502fca",
  null
  
)

export default component.exports